module.exports = __webpack_public_path__ + "static/media/SelectedBulbGreen.79545cd2.svg";